import { Row } from "./Flexbox";
import Text from "../components/Text";


const CustomerRow = props => {
    const backgroundColor = props.isActive ? props.theme.Ey : props.isHover ? props.theme.Ed : props.theme.Alfalfa;
    const weight = props.isActive ? "bold" : "normal";
    
    return (
        <Row
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            style={{
                backgroundColor,
                padding: 10,
                borderRadius: 4,
                gap: 16,
                width: '100%',
                maxHeight: 52,
                ...props.style,
            }}
        >
            <Text weight = {weight} style={{color: props.theme.Black, marginLeft: 10, cursor:'pointer'}} size={15}>{props.data.id}</Text>
            <Text weight = {weight} style={{color: props.theme.Black, marginLeft: 24, flex: 1, cursor:'pointer'}} size={15}>{props.data.nombre}</Text>
            <Text weight = {weight} style={{color: props.theme.Black, cursor:'pointer'}} size={15}>{props.data.granTotal.toLocaleString('es-MX', {style: 'currency', currency: 'MXN'})}</Text>
        </Row>
    );
};
export default CustomerRow;